import angular from "angular";

angular
    .module('app')
    .component('permissionForm', {
        template: require('./permission-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.name = null;
    $ctrl.label = null;
    $ctrl.type = null;
    $ctrl.module = null;

    $ctrl.$onInit = function () {

        $ctrl.modules = $ctrl.resolve.modules;
        $ctrl.module = $ctrl.resolve.module;

        if ($ctrl.resolve.permission) {
            $ctrl.id = $ctrl.resolve.permission.id;
            $ctrl.name = $ctrl.resolve.permission.name;
            $ctrl.label = $ctrl.resolve.permission.label;
        }


    };

    $ctrl.submit = function () {

        let req = null;
        $ctrl.loading = true;

        let params = {
            name: $ctrl.name,
            label: $ctrl.label,
            module_id: $ctrl.module.id
        };

        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/admin/permissions/${$ctrl.id}`, params);


        } else {
            req = $http.post('/admin/permissions', params);
        }

        req.then(
            function (response) {
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    Notifier.success('Разрешение успешно добавлена', 2);
                } else {
                    Notifier.success('Разрешение успешно обновлена', 2);
                }


                $ctrl.loading = false;
                $ctrl.close({$value: {id: $ctrl.id, name: $ctrl.name, label: $ctrl.label}});

            },

            function (error) {
                $ctrl.loading = false;
                Notifier.error('Произошла ошибка', 2);
            }
        );
    };

}
